import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { InputTooltipSharedComponent } from './input-tooltip.component';
import { InputAtomSharedModule } from '../../atoms/input/input.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        InputTooltipSharedComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,

        InputAtomSharedModule,
        IconSharedModule
    ],
    exports: [
        InputTooltipSharedComponent
    ]
})

export class InputTooltipSharedModule {}
